export default __webpack_public_path__ + "static/media/qtitle.7a7cab1b.svg";